import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getNewComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const newComics = getNewComics();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}>
              最新上架
            </h2>
            <p className="text-sm text-foreground-400 mt-2">刚刚上架的全新韩漫作品</p>
          </div>
          <Link
            to="/category/love?tab=new"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {newComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}